export const validateOriginLocation = (
  countryCode,
  originDaneCode,
  originName,
  originDepName,
) => {
  if (countryCode === '170') {
    return `${originName}-${originDepName}`;
  }
  return `${originDaneCode}-${originName}-${originDepName}`;
};

export const validateDestinyLocation = (
  countryCode,
  destinyDaneCode,
  destinyName,
  destinyDepName,
) => {
  if (countryCode === '170') {
    return `${destinyName}-${destinyDepName}`;
  }
  return `${destinyDaneCode}-${destinyName}-${destinyDepName}`;
};

export const validateComments = (comment) => (comment === 'NA' ? '' : comment);
